export default {
  hub: {
    account: {
      environments: {
        staging: {
          details: {
            label: 'Account',
            href: '/my-account/details'
          }
        },
        preproduction: {
          details: {
            label: 'Account',
            href: '/my-account/details'
          }
        }
      }
    }
  }
};